module.exports = __webpack_public_path__ + "img/hamburger.25467573.svg";